"use strict";
/* eslint-disable react/prop-types */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.saveCommentReply = void 0;
var react_1 = __importDefault(require("react"));
var comments_1 = require("../../actions/comments");
var CommentHeader_1 = require("../CommentHeader");
var TextArea_1 = __importDefault(require("../TextArea"));
var Icon_1 = __importDefault(require("../../../Icon/Icon"));
function saveCommentReply(comment, reply, store) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                mode: 'saving',
            }));
            try {
                store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                    mode: 'default',
                    text: reply.newText,
                    author: reply.author,
                }));
            }
            catch (err) {
                /* eslint-disable-next-line no-console */
                console.error(err);
                store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                    mode: 'save_error',
                }));
            }
            return [2 /*return*/];
        });
    });
}
exports.saveCommentReply = saveCommentReply;
function deleteCommentReply(comment, reply, store) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                mode: 'deleting',
            }));
            try {
                store.dispatch(comments_1.deleteReply(comment.localId, reply.localId));
            }
            catch (err) {
                store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                    mode: 'delete_error',
                }));
            }
            return [2 /*return*/];
        });
    });
}
var CommentReplyComponent = /** @class */ (function (_super) {
    __extends(CommentReplyComponent, _super);
    function CommentReplyComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommentReplyComponent.prototype.renderEditing = function () {
        var _this = this;
        var _a = this.props, comment = _a.comment, reply = _a.reply, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        var onChangeText = function (value) {
            store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                newText: value,
            }));
        };
        var onSave = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, saveCommentReply(comment, reply, store)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var onCancel = function (e) {
            e.preventDefault();
            store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                mode: 'default',
                newText: reply.text,
            }));
        };
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: reply, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("form", { onSubmit: onSave },
                react_1["default"].createElement(TextArea_1["default"], { className: "comment-reply__input", value: reply.newText, onChange: onChangeText }),
                react_1["default"].createElement("div", { className: "comment-reply__actions" },
                    react_1["default"].createElement("button", { type: "submit", disabled: reply.newText.length === 0, className: "comment-reply__button comment-reply__button--primary" }, strings.SAVE),
                    react_1["default"].createElement("button", { type: "button", className: "comment-reply__button", onClick: onCancel }, strings.CANCEL)))));
    };
    CommentReplyComponent.prototype.renderSaving = function () {
        var _a = this.props, reply = _a.reply, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: reply, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment-reply__text" }, reply.text),
            react_1["default"].createElement("div", { className: "comment-reply__progress" }, strings.SAVING)));
    };
    CommentReplyComponent.prototype.renderSaveError = function () {
        var _this = this;
        var _a = this.props, comment = _a.comment, reply = _a.reply, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        var onClickRetry = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, saveCommentReply(comment, reply, store)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: reply, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment-reply__text" }, reply.text),
            react_1["default"].createElement("div", { className: "comment-reply__error" },
                strings.SAVE_ERROR,
                react_1["default"].createElement("button", { type: "button", className: "comment-reply__button", onClick: onClickRetry }, strings.RETRY))));
    };
    CommentReplyComponent.prototype.renderDeleteConfirm = function () {
        var _this = this;
        var _a = this.props, comment = _a.comment, reply = _a.reply, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        var onClickDelete = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, deleteCommentReply(comment, reply, store)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var onClickCancel = function (e) {
            e.preventDefault();
            store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                mode: 'default',
            }));
        };
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: reply, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment-reply__text" }, reply.text),
            react_1["default"].createElement("div", { className: "comment-reply__confirm-delete" },
                strings.CONFIRM_DELETE_COMMENT,
                react_1["default"].createElement("button", { type: "button", className: "comment-reply__button", onClick: onClickCancel }, strings.CANCEL),
                react_1["default"].createElement("button", { type: "button", className: "comment-reply__button comment-reply__button--primary", onClick: onClickDelete }, strings.DELETE))));
    };
    CommentReplyComponent.prototype.renderDeleting = function () {
        var _a = this.props, reply = _a.reply, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: reply, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment-reply__text" }, reply.text),
            react_1["default"].createElement("div", { className: "comment-reply__progress" }, strings.DELETING)));
    };
    CommentReplyComponent.prototype.renderDeleteError = function () {
        var _this = this;
        var _a = this.props, comment = _a.comment, reply = _a.reply, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        var onClickRetry = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, deleteCommentReply(comment, reply, store)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var onClickCancel = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                e.preventDefault();
                store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                    mode: 'default',
                }));
                return [2 /*return*/];
            });
        }); };
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: reply, store: store, strings: strings, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment-reply__text" }, reply.text),
            react_1["default"].createElement("div", { className: "comment-reply__error" },
                strings.DELETE_ERROR,
                react_1["default"].createElement("button", { type: "button", className: "comment-reply__button", onClick: onClickCancel }, strings.CANCEL),
                react_1["default"].createElement("button", { type: "button", className: "comment-reply__button", onClick: onClickRetry }, strings.RETRY))));
    };
    CommentReplyComponent.prototype.renderDefault = function () {
        var _a = this.props, comment = _a.comment, reply = _a.reply, store = _a.store, strings = _a.strings, isFocused = _a.isFocused;
        // Show edit/delete buttons if this reply was authored by the current user
        var onEdit;
        var onDelete;
        if (reply.author === null || this.props.user && this.props.user.id === reply.author.id) {
            onEdit = function () {
                store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                    mode: 'editing',
                    newText: reply.text,
                }));
            };
            onDelete = function () {
                store.dispatch(comments_1.updateReply(comment.localId, reply.localId, {
                    mode: 'delete_confirm',
                }));
            };
        }
        var notice = '';
        if (!reply.remoteId || reply.text !== reply.originalText) {
            // Save the page to save this reply
            notice = strings.SAVE_PAGE_TO_SAVE_REPLY;
        }
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(CommentHeader_1.CommentHeader, { commentReply: reply, store: store, strings: strings, onEdit: onEdit, onDelete: onDelete, focused: isFocused }),
            react_1["default"].createElement("p", { className: "comment-reply__text" }, reply.text),
            notice &&
                react_1["default"].createElement("div", { className: "comment__notice-placeholder" },
                    react_1["default"].createElement("div", { className: "comment__notice", role: "status" },
                        react_1["default"].createElement(Icon_1["default"], { name: "info-circle" }),
                        notice))));
    };
    CommentReplyComponent.prototype.render = function () {
        var inner;
        switch (this.props.reply.mode) {
            case 'editing':
                inner = this.renderEditing();
                break;
            case 'saving':
                inner = this.renderSaving();
                break;
            case 'save_error':
                inner = this.renderSaveError();
                break;
            case 'delete_confirm':
                inner = this.renderDeleteConfirm();
                break;
            case 'deleting':
                inner = this.renderDeleting();
                break;
            case 'delete_error':
                inner = this.renderDeleteError();
                break;
            default:
                inner = this.renderDefault();
                break;
        }
        return (react_1["default"].createElement("li", { key: this.props.reply.localId, className: "comment-reply comment-reply--mode-" + this.props.reply.mode, "data-reply-id": this.props.reply.localId }, inner));
    };
    return CommentReplyComponent;
}(react_1["default"].Component));
exports["default"] = CommentReplyComponent;
